import { TaskType } from "@coworker/apprestructured/src/tasks/enums/taskTypes";

export function getTaskTypeTranslateString(taskType: `${TaskType}`) {
  switch (taskType) {
    case "PRODUCT_ISSUE":
      return "productString";
    case "ADDON":
      return "addonTitleString";
    case "CUSTOM":
      return "customString";
    case "PLANNED":
      return "mainScheduledTaskString";
    case "MFAQ_FOLLOW_UP":
      return "mfaqFollowUpTitle";
    case "PRODUCT_QUALITY":
      return "productQualityReportString";
    case "TESTBUY_FOLLOW_UP":
      return "testBuyFollowUpString";
    case "ROOM_SETTINGS":
      return "mediaMaintenanceString";
    case "NO_TASK_TYPE":
      return "";
  }
}
